import { AssignedOfficialComponent } from './../../_shared/components/officials/assigned-official/assigned-official.component';
import { ClocksComponent } from './../../clocks/clocks.component';
import { ScoreDelayComponent } from './../../_shared/components/score-delay/score-delay.component';
import { VideoStreamProviderService } from './../../video-stream-provider-list/video-stream-provider.service';
import { VideoStreamProviderListComponent } from './../../video-stream-provider-list/video-stream-provider-list.component';
import { CourtSide } from './../../_shared/models/enums/court-side';
import { ScoreService } from '../../match-tracker/tracker-board/services/score.service';
import { Location } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ActionSheetButton,
  ActionSheetController,
  AlertController,
  IonRouterOutlet,
  ModalController,
  NavController,
  PopoverController,
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BoardHelpService } from '../../match-tracker/tracker-board/board-help.service';
import { TrackingModesComponent } from '../../match-tracker/tracking-modes/tracking-modes.component';
import { WeatherUpdateComponent } from '../../match-tracker/weather-update/weather-update.component';
import { CreateMatchComponent } from '../../matches/create-match/create-match.component';
import { MatchService } from '../../_core/services/match.service';
import { ToastService } from '../../_core/services/toast.service';
import { TrackersComponent } from '../../_shared/components/trackers/trackers.component';
import { MatchUpStatusEnum } from '../../_shared/models/csTypes/enums/matchup_status';
import { TieService } from '../../_core/services/tie.service';
import { Match, ScheduledItem } from '../../_shared/models/match.model';
import { MatchOptionsComponent } from '../match-options/match-options.component';
import { TrackerBarService } from './tracker-bar.service';
import { SocketService } from '../../_core/services/socket.service';
import { BatteryInfo, Device } from '@capacitor/device';
import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import { TieDetailsService } from '../../ties/tie-details/tie-details.service';
import { TournamentDetailsService } from '../../tournaments/tournament-details/tournament-details.service';
import { AuthService } from '../../auth/auth.service';
import { DisciplineEnum } from '../../_shared/models/csTypes/enums/discipline';
import { PickleballTrackerBrainService } from '../../match-tracker/tracker-board/services/pickleball/pickleball-tracker-brain.service';
import { ServerService } from '../../match-tracker/tracker-board/services/server.service';
import { ScoreFormat, SetType, TimedPointsOrGames } from '../../_shared/models/score-format.model';
import { AdditionalPlayerInfoComponent } from '../additional-player-info/additional-player-info.component';
import { Tournament } from '../../_shared/models/tournament.model';
import { AssignVideoBoardComponent } from '../assign-video-board/assign-video-board.component';
import { ManageSubstitutionComponent } from '../../manage-substitution/manage-substitution.component';
import { ManageScoreSubscriptionComponent } from '../manage-score-subscription/manage-score-subscription.component';
import { IntennseService } from '../../intennse-official-view/intennse.service';
import { BreakClockService } from '../../_shared/components/break-clock/break-clock.service';
import { Venue } from '../../_shared/models/csTypes/venue';
import { Court } from '../../_shared/models/csTypes/court';

@Component({
  standalone: false,
  selector: 'app-tracker-bar',
  templateUrl: './tracker-bar.component.html',
  styleUrls: ['./tracker-bar.component.scss'],
})
export class TrackerBarComponent implements OnInit, OnDestroy {
  private serverService = inject(ServerService);
  private authService = inject(AuthService);
  private breakClockService = inject(BreakClockService);

  @Input() match: Match;
  @Input() hideMatchMoreOptions: boolean = false;
  @Input() isTracker: boolean;
  @Input() isOwner = false;
  @Input() venue: Venue;
  @Input() court: Court;
  @Output() undo = new EventEmitter<any>();
  @Output() changeScoringTypeEmit = new EventEmitter<boolean>();
  @Output() stopTimedSet = new EventEmitter<void>();

  private readonly destroy$: Subject<void> = new Subject();
  batteryInfo: BatteryInfo;
  batteryIcon: string;
  isPointByPoint = false;
  isTournamentOwner: boolean;
  isTournamentTracker: boolean;
  allowScoreSubmissionToPartner: boolean;
  allowAutoSubmitScore: boolean;
  scoreFormat: ScoreFormat;
  assignCourtWhenSavingCamera: boolean;
  tournament: Tournament;
  assignVideoBoard: boolean = false;
  private scoringSubscription!: Subscription;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly tieService: TieService,
    private readonly navController: NavController,
    public readonly bhs: BoardHelpService,
    private readonly location: Location,
    private readonly modalController: ModalController,
    private alertController: AlertController,
    private actionSheetController: ActionSheetController,
    private popoverController: PopoverController,
    private trackerBarService: TrackerBarService,
    private toast: ToastService,
    private routerOutlet: IonRouterOutlet,
    private matchService: MatchService,
    private translateService: TranslateService,
    private socketService: SocketService,
    private tieDetailsService: TieDetailsService,
    private tournamentDetailsService: TournamentDetailsService,
    private scoreService: ScoreService,
    private videoStreamProviderService: VideoStreamProviderService,
    private pickleballTrackerBrainService: PickleballTrackerBrainService,
    private intennseService: IntennseService
  ) {}



  async ngOnInit() {
    this.scoreFormat = this.bhs.getScoreFormat(
      this.match.matchFormat,
      this.match.discipline
    );
    if (Capacitor.isNativePlatform()) {
      this.batteryInfo = await Device.getBatteryInfo();
      if (this.batteryInfo.batteryLevel > 0.6)
        this.batteryIcon = 'battery-full-outline';
      else if (this.batteryInfo.batteryLevel > 0.2)
        this.batteryIcon = 'battery-half-outline';
      else this.batteryIcon = 'battery-dead-outline';
    }
    // this.isPointByPoint = this.bhs.getLastGame(this.match)?.currentScoringType == 'pointByPoint'? true: false;
    // this.changeScoringType(this.isPointByPoint);

    // if (this.match.discipline === DisciplineEnum.PICKLEBALL) {
    //   // If pickleball set default to point by point
    //   this.changeScoringType();
    // } else if (this.match.discipline === DisciplineEnum.BADMINTON) {
    //   // If badminton set default to point by point
    //   this.changeScoringType(true);
    // } else {
    //   const storageValue = (
    //     await Preferences.get({ key: `${this.match._id}-isPointByPoint` })
    //   ).value;
    //   const isPointByPoint = storageValue && storageValue !== 'false'? true: false;
    //   this.changeScoringType(isPointByPoint)
    if (this.match.discipline === DisciplineEnum.PICKLEBALL || this.match.discipline === DisciplineEnum.BADMINTON || this.match.discipline === DisciplineEnum.TABLE_TENNIS || this.match.discipline === DisciplineEnum.SQUASH) {
      // If pickleball set default to point by point
      this.changeScoringType();
      } else {
          const storageValue = (await Preferences.get({ key: `${this.match._id}-isPointByPoint` })).value;
          if (storageValue && String(this.isPointByPoint) !== storageValue) {
              this.changeScoringType();
          }
      }    
    if (this.match.tournament) {
      this.tournament = await this.tournamentDetailsService.getTournamentInfo(
        this.match.tournament
      );
      this.allowScoreSubmissionToPartner =
      this.tournament.allowResultSubmissionToPartner;
      this.allowAutoSubmitScore = 
      this.tournament.allowAutoSubmitScore;

      this.isTournamentOwner = this.tournament?.owners?.some(
        (owner) => owner === this.authService.authUserSignal()?._id
      );
      this.isTournamentTracker = this.tournament?.trackers?.some(
        (t) => t.tracker?._id === this.authService.authUserSignal()?._id
      );
    }
    this.scoringSubscription = this.matchService.subscribeAutoSwitchScoringTypeOnTieBreak()
    .subscribe(result=>{
      if(result.matchId === this.match._id) {
        this.changeScoringTypeOnTieBreak(result)
      }
    })
    // TODO: Currently not working as expected, expected ticket is in progress IOCINIT-568
    // this.updateMatchPointByPoint();    
  }

  updateMatchPointByPoint() {
    this.matchService.subscribeScoreUpdated()
        .pipe(takeUntil(this.destroy$))
        .subscribe((updatedMatch) => {
          this.isPointByPoint = this.bhs.getLastGame(updatedMatch)?.currentScoringType == 'pointByPoint'? true: false;
          this.changeScoringType(this.isPointByPoint);
    })
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.scoringSubscription.unsubscribe();
  }

  async showMoreOptions() {
    const modal = await this.modalController.create({
      component: MatchOptionsComponent,
      componentProps: {
        match: this.match,
        isOwner: this.isOwner,
        isPointByPoint: this.isPointByPoint,
      },
      presentingElement: this.routerOutlet.nativeEl,
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (data) {
      switch (data) {
        case 'advanced-tracking':
          this.openMatchTracker();
          break;
        case 'official-view':
          this.openOfficialView();
          break;
        case 'remove-from-live-score':
          this.manageLiveScore([]);
          break;
        case 'assign-court':
          this.assignCourt();
          break;
        case 'assign-smart-court':
          this.assignSmartCourt();
          break;
        case 'tracking-mode':
          await this.updateTrackingMode();
          break;
        case 'add-tracker':
          this.viewTrackers();
          break;
        case 'add-official':
          this.viewOfficials();
          break;
        case 'change-server':
          await this.serverService.selectServer(this.match);
          this.match.score = this.scoreService.getScoreObject(this.match);
          break;
        case 'change-returner':
          await this.changeReturningSide();
          this.match.score = this.scoreService.getScoreObject(this.match);
          break;
        case 'stop-match':
          await this.stopMatch();
          break;
        case 'walkover':
          await this.retireMatch(MatchUpStatusEnum.WALKOVER);
          break;
        case 'weather':
          await this.weatherUpdate();
          break;
        case 'edit':
          await this.editMatch();
          break;
        case 'delete':
          await this.deleteMatch();
          break;
        case 'camera':
          await this.addCamera();
          break;
        case 'score-delay':
          await this.scoreDealy();
          break;
        case 'point-by-point':
          await this.changeScoringType();
          break;
        case 'manage-clocks':
          await this.manageClocks();
          break;
        case 'additional-information':
          await this.updateAdditionalInformation();
          break;
        case 'temp-intennse':
          this.openTempIntennseView();
          break;
        case 'swip-teams':
          this.swipMatchSide();
          break;
        case 'manage-substitution':
          this.manageSubstitution();
          break;
        case 'subscribe-to-score-updates':
          this.openManageScoreSubscriptionModal();
          break;
        case 'break-clock':
          this.startBreak();
          break;
        default:
          // console.log(data);
          break;
      }
    }
  }
  private async updateAdditionalInformation() {
    const modal = await this.modalController.create({
      component: AdditionalPlayerInfoComponent,
      componentProps: {
        match: this.match,
      },
    });

    await modal.present();
  }

  async manageClocks() {
    const modal = await this.modalController.create({
      component: ClocksComponent,
      componentProps: { match: this.match },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.match.clocks = data;
    }

    if(data === null){
        this.match.score = this.scoreService.getScoreObject(this.match);
        this.matchService.publishScoreUpdated(this.match);
    }
  }

  private async scoreDealy() {
    const popover = await this.popoverController.create({
      component: ScoreDelayComponent,
      componentProps: {
        match: this.match,
      },
      cssClass: 'mt-popover',
      translucent: false,
    });

    await popover.present();
  }

  async addCamera() {
    const modal = await this.modalController.create({
      component: VideoStreamProviderListComponent,
      componentProps: {
        playsightLink: `https://ioncourt.com/live-scoring/${this.match._id}/playsight`,
        match: this.match,
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (data) {
      this.shouldAssignCourtWhenSavingCamera(data);
    }
  }

  async shouldAssignCourtWhenSavingCamera(data) {
    const alert = await this.alertController.create({
      header: 'Set court name as camera name?',
      message: 'If you select yes, court name will be updated to camera name',
      buttons: [
        {
          text: 'No',
          handler: () => {
            this.assignCourtWhenSavingCamera = false;
          },
        },
        {
          text: 'Yes',
          handler: () => {
            this.assignCourtWhenSavingCamera = true;
          },
        },
      ],
    });

    await alert.present();

    await alert.onDidDismiss();
    this.saveCamera(data);
  }

  async saveCamera(data, removeOldCameras?: boolean, keepVideoLink?: boolean) {
    this.videoStreamProviderService
      .saveCameraToMatch(
        data,
        this.match._id,
        removeOldCameras || false,
        this.assignCourtWhenSavingCamera,
        keepVideoLink || false
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (res) => {
        if (res.data.matchWithCamera) {
          const alert = await this.alertController.create({
            header: this.translateService.instant('Device is in use'),
            message: this.translateService.instant('This device is currently assigned to another match. Do you want to save the video recording from that match?'),
            buttons: [
              {
                text: this.translateService.instant('Don\'t save and remove'),
                role: 'destructive',
                handler: () => {
                  this.saveCamera(data, true, false);
                }
              },
              {
                text: this.translateService.instant('Save and remove'),
                handler: () => {
                  this.saveCamera(data, true, true);
                }
              },
              {
                text: this.translateService.instant('Cancel'),
                role: 'cancel'
              }
            ]
          });

          await alert.present();
        } else {
          this.match.cameras = res.data.cameras;
          if (res.data.videoLinks) {
            this.match.videoLinks = res.data.videoLinks;
          }

          if (this.assignCourtWhenSavingCamera) {
            let extensionIndex = this.match.extensions?.findIndex(
              (e) => e.name === 'court'
            );

            if (extensionIndex && extensionIndex > -1 && this.match?.extensions) {
              this.match.extensions[extensionIndex].value = {
                courtName: data.name,
              };
            } else {
              this.match.extensions?.push({
                name: 'court',
                value: { courtName: data.name },
              });
            }
          }

          this.toast.presentToast(res.message);
        }
      });
  }

  manageLiveScore(matchUpStatusCodes: string[]) {
    this.match.matchUpStatusCodes = matchUpStatusCodes;
  
    let request$;
  
    if (this.venue && this.court) {
      request$ = this.matchService.startLiveScoreTournamentMatch(
        this.match,
        false,
        null,
        this.court?.courtId,
        this.venue?.venueId
      );
    } else {
      request$ = this.matchService.update(this.match, false);
    }
  
    request$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        const match: Match = res.data;
        this.trackerBarService.publishStartLiveScore(match);
      });
  }

  async assignCourt() {
    const alert = await this.alertController.create({
      header: this.translateService.instant('Assign court'),
      inputs: [
        {
          name: 'courtName',
          type: 'text',
          placeholder: this.translateService.instant('Court name'),
        },
      ],
      buttons: [
        {
          text: this.translateService.instant('Cancel'),
          role: 'cancel',
          cssClass: 'secondary',
        },
        {
          text: this.translateService.instant('Okay'),
          handler: (data) => {
            const { courtName } = data;
            this.trackerBarService
              .assignCourt(this.match._id, { courtName })
              .pipe(takeUntil(this.destroy$))
              .subscribe(
                (res) => {
                  const index = this.match.extensions.findIndex(
                    (ext) => ext.name === 'court'
                  );

                  index > -1
                    ? (this.match.extensions[index].value = { courtName })
                    : this.match.extensions.push({
                        name: 'court',
                        value: { courtName },
                      });
                  this.matchService.publishEdit(this.match);
                  this.toast.presentToast(res.message);
                },
                (err) => {
                  //console.log(err);
                }
              );
          },
        },
      ],
    });

    await alert.present();
  }

  private async stopMatch() {
    const buttons: ActionSheetButton[] = [
      {
        text: this.translateService.instant('Retire'),
        handler: () => {
          this.retireMatch(MatchUpStatusEnum.RETIRED);
        },
      },
      {
        text: this.translateService.instant('Incomplete'),
        handler: () => {
          this.incompleteMatch(MatchUpStatusEnum.INCOMPLETE);
        },
      },
      {
        text: this.translateService.instant('Abandoned'),
        handler: () => {
          this.incompleteMatch(MatchUpStatusEnum.ABANDONED);
        },
      },
    ];

    if (!this.location.path().includes('official-view')) {
      buttons.push({
        text: this.translateService.instant('Suspend'),
        handler: () => {
          this.suspendMatch();
        },
      });
    }

    if (this.scoreFormat.setType === SetType.TIMED) {
      buttons.unshift({
        text: this.translateService.instant('Stop timed set'),
        handler: () => {
          this.stopTimedSet.emit();
        },
      });
    }

    const actionSheet = await this.actionSheetController.create({
      header: this.translateService.instant('Stop match options'),
      buttons: buttons,
    });

    await actionSheet.present();
  }

  private async suspendMatch() {
    const alert = await this.alertController.create({
      header: this.translateService.instant('Suspend match'),
      message: this.translateService.instant('Enter the reason for suspending the match'),
      inputs: [
        {
          name: 'note',
          placeholder: this.translateService.instant('Enter note'),
        },
      ],
      buttons: [
        {
          text: 'Suspend',
          handler: async (data) => {
            this.match.matchStatus = MatchUpStatusEnum.SUSPENDED;

            await this.trackerBarService
              .changeMatchStatus(
                this.match._id,
                MatchUpStatusEnum.SUSPENDED,
                null
              )
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: async (res) => {
                  this.matchService.publishEdit(this.match);
                  this.match.matchStatus = MatchUpStatusEnum.SUSPENDED;
                  this.updateMatchScore();
                },
              });

            const scheduledItemObj: ScheduledItem = {
              itemType: 'startTime',
              itemSubject: 'SUSPENSION',
              note: data.note,
            };

            await this.matchService
              .addScheduledItem(scheduledItemObj, this.match._id)
              .pipe(takeUntil(this.destroy$))
              .subscribe((res) => {
                this.match.scheduledItems = res.data;
              });

            
          },
        },
        {
          text: 'Cancel',
        },
      ],
    });
    await alert.present();
  }

  private async updateMatchScore(){
    this.match.score = this.scoreService.getScoreObject(this.match);
     this.matchService.updateScore({
        matchId: this.match._id,
        sets: this.match.sets,
        score: this.match.score,
        playerCourtTimeLog: this.match.playerCourtTimeLog,
        substituteTrack: this.match.substituteTrack,
        isUndo: false
     }
        ).pipe(takeUntil(this.destroy$)).subscribe({
          next: (res) => {
            this.match = res.data;
          }
    });
  }

  private async weatherUpdate() {
    const popover = await this.popoverController.create({
      component: WeatherUpdateComponent,
      componentProps: {
        match: this.match,
      },
      cssClass: 'mt-popover',
    });

    await popover.present();

    const { data } = await popover.onDidDismiss();
    if (data) {
      this.match.weather = data;
    }
  }

  private async retireMatch(matchUpStatus: MatchUpStatusEnum) {
    const sideNumber = await this.bhs.selectSide(
      this.match,
      true,
      this.translateService.instant('Who is retiring?')
    );

    if (sideNumber) {
      this.match.matchStatus = matchUpStatus;
      this.match.winningSide = sideNumber === 1 ? 2 : 1;
      this.match.endDate = new Date();
      this.match.score = this.scoreService.getScoreObject(this.match);

      this.matchService
        .update(this.match, false)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: async () => {
            if (this.match.tie) {
              const tie = await this.tieDetailsService.getTieInfo(
                this.match.tie,
                false,
                false,
                'tracker-bar ln 341'
              );
              this.tieDetailsService.tieStatusUpdate(true);
            }
            this.matchService.publishScoreUpdated(this.match);
            this.matchService.publishEdit(this.match);
            this.socketService.updateMatch(this.match);
            this.updateMatchScore();
          },
        });
    }
  }

  private async incompleteMatch(matchUpStatus: MatchUpStatusEnum) {
    this.match.matchStatus = matchUpStatus === MatchUpStatusEnum.INCOMPLETE ? MatchUpStatusEnum.INCOMPLETE :  MatchUpStatusEnum.ABANDONED;    
    this.trackerBarService
      .changeMatchStatus(this.match._id, matchUpStatus, new Date())
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: async (res) => {
          if (this.match.tie) {
            const tie = await this.tieDetailsService.getTieInfo(
              this.match.tie,
              false,
              false,
              'tracker-bar ln 341'
            );
            this.tieDetailsService.tieStatusUpdate(true);
          }
          this.matchService.publishEdit(this.match);
          this.match.matchStatus = matchUpStatus;
          this.socketService.updateMatch(this.match);
          this.toast.presentToast(res.message);
          this.updateMatchScore();
        },
      });
  }

  async updateTrackingMode() {
    const popover = await this.popoverController.create({
      component: TrackingModesComponent,
      componentProps: {
        match: this.match,
      },
      translucent: false,
      cssClass: 'mt-popover',
    });

    await popover.present();

    const { data } = await popover.onDidDismiss();
    if (data) {
      this.match.dist.tracking = data;
    }
  }

  openMatchTracker() {
    const params = this.activatedRoute.snapshot.params;

    if (
      this.router.url.includes('individual') ||
      this.router.url.includes('tournaments') ||
      this.router.url.includes('official-view')
    ) {
      this.navController.navigateForward(['live-scoring/' + this.match._id]);
    } else if (params.id && params.tieId) {
      const id = this.activatedRoute.snapshot.params.id;
      const updatedUrl = this.router.url.replace(id, this.match._id);
      this.location.go(updatedUrl);

      this.tieService.publishMatchChange(this.match._id);
    } else {
      this.navController.navigateForward(
        `ties/${params.tieId}/match/${this.match._id}`
      );
    }
  }

  openOfficialView() {
    this.navController.navigateForward(['official-view/' + this.match._id]);
  }

  openTempIntennseView() {
    this.navController.navigateForward([
      'intennse-official-view/' + this.match._id,
    ]);
  }

  // Call the swapSides() method
  swipMatchSide() {    
    if(this.router.url.includes('intennse-official-view')){
      this.intennseService.triggerSwapSides();
    }
  }

  async viewTrackers() {
    const modal = await this.modalController.create({
      component: TrackersComponent,
      componentProps: {
        match: this.match,
      },
      presentingElement: this.routerOutlet.nativeEl,
    });

    await modal.present();
  }

  async viewOfficials() {
    const modal = await this.modalController.create({
      component: AssignedOfficialComponent,
      componentProps: {
        _matchId: this.match._id,
        _tournamentId: this.match.tournament,
        match: this.match,
      },
      presentingElement: this.routerOutlet.nativeEl,
    });

    await modal.present();
  }

  private async editMatch() {
    const modal = await this.modalController.create({
      component: CreateMatchComponent,
      presentingElement: this.routerOutlet.nativeEl,
      componentProps: {
        match: this.match,
        tieId: this.match.tie,
        tournament: this.match.tournament,
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (data) {
      this.match = data.match;
      this.matchService.publishEdit(this.match);
      this.socketService.updateMatch(this.match);
    }
  }

  async deleteMatch() {
    this.translateService
      .get([
        'Delete match',
        'Are you sure that you want to delete this match?',
        'Yes, delete',
        'No, keep it',
      ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (translations) => {
        const alert = await this.alertController.create({
          id: 'delete-match',
          header: translations['Delete match'],
          message:
            translations['Are you sure that you want to delete this match?'],
          buttons: [
            {
              text: translations['Yes, delete'],
              role: 'destructive',
              handler: () => {
                this.matchService
                  .delete(this.match._id)
                  .pipe(takeUntil(this.destroy$))
                  .subscribe({
                    next: (res) => {
                      this.matchService.publishDelete(this.match);
                      this.toast.presentToast(res.message);
                    },
                  });
              },
            },
            {
              text: translations['No, keep it'],
            },
          ],
        });

        await alert.present();
      });
  }

  // async changeScoringType(isPointByPoint?: boolean) {
    
  //   this.isPointByPoint = isPointByPoint ?? !this.isPointByPoint;
  //   let scoringType = this.isPointByPoint ? "pointByPoint" : "gameByGame";
  //   // TODO: comment this out for now as it is not working as expected, expected ticket is in progress IOCINIT-568
  //   // this.matchService.publishTrackerChangedScoringType({matchId: this.match._id, scoringType: scoringType});
  //   // await Preferences.set({
  //   //   key: `${this.match._id}-isPointByPoint`,
  //   //   value: String(this.isPointByPoint),
  //   // });
  //   this.changeScoringTypeEmit.emit(this.isPointByPoint);
  // }
  async changeScoringType(isPointByPoint?: boolean) {
    this.isPointByPoint = isPointByPoint ?? !this.isPointByPoint;
    await Preferences.set({ key: `${this.match._id}-isPointByPoint`, value: String(this.isPointByPoint) });
    this.changeScoringTypeEmit.emit(this.isPointByPoint);
  }

  canScoreMatch(): boolean {
    if (this.match.sets && this.matchService.isTracker(this.match) || (this.bhs.isUserFan && this.match.allowFansToScore)) {
      if (
        this.match.tournament &&
        !this.match.matchUpStatusCodes.some(
          (matchUpStatusCode) => matchUpStatusCode === 'LIVE_SCORE'
        )
      ) {
        return false;
      }
      return true;
    }

    return false;
  }

  submitScoreToPartner() {
    this.trackerBarService
      .submitScoreToPartner(
        this.match._id,
        this.match.tournament,
        this.match.source.partner
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.toast.presentToast(res.message);
        },
      });
  }

  private async changeReturningSide() {
    const sideNumber = await this.bhs.selectSide(
      this.match,
      true,
      'Select side'
    );

    if (sideNumber) {
      this.bhs.getLastSet(this.match).returnerCourtSides.forEach((rcs) => {
        if (rcs.sideNumber === sideNumber) {
          rcs.courtSide =
            rcs.courtSide === CourtSide.DEUCE ? CourtSide.AD : CourtSide.DEUCE;
        }
      });
      this.matchService.publishScoreUpdated(this.match);
    }
  }

  async changePickleballServer() {
    const lastPoint = this.bhs.getLastPoint(this.match);
    const selectedServer =
      await this.pickleballTrackerBrainService.selectServer(
        this.match,
        true,
        lastPoint.server.serverNumber,
        lastPoint.server.sideNumber
      );

    if (!selectedServer) return;

    lastPoint.server.sideNumber = selectedServer.sideNumber;
    lastPoint.server.serverNumber = selectedServer.serverNumber;
    lastPoint.server.playerNumber = selectedServer.playerNumber;
    lastPoint.server.player = selectedServer.player;

    this.bhs.getLastSet(this.match).serverPickleballOrders =
      this.pickleballTrackerBrainService.setServerOrder(
        this.match,
        lastPoint.server
      );
    // await this.updateScore();
    this.matchService.publishEdit(this.match);
  }

  private async assignSmartCourt() {
    const modal = await this.modalController.create({
      component: AssignVideoBoardComponent,
      componentProps: {
        match: this.match,
        venues: this.tournament?.venues,
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();

    if (data) {
      this.match = data;
      this.matchService.publishEdit(data);
    }
  }

  async manageSubstitution(){
    const modal = await this.modalController.create({
        component: ManageSubstitutionComponent,
        componentProps: { match: this.match },
      });
  
      await modal.present();
  }
  
  async openManageScoreSubscriptionModal() {
    const modal = await this.modalController.create({
      component: ManageScoreSubscriptionComponent,
      componentProps: { match: this.match},
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.match.scoreSubscribers = data;
      this.matchService.publishEdit(this.match);
    }
  }

  async startBreak() {
    this.breakClockService.publishBreakClock();
  }

  async changeScoringTypeOnTieBreak(result: any) {
    this.isPointByPoint = result.currentScoringType == 'pointByPoint'? true: false;
    this.changeScoringTypeEmit.emit(this.isPointByPoint);
  }
}
